<template>
  <b-dropdown :variant="variant" menu-class="constrained" size="sm" right :disabled="disabled">
    <template v-slot:button-content>
      <span>{{ label }}</span>
    </template>
    <b-dropdown-item
      v-for="(f, index) in items" :key="'person_'+index"
      size="sm"
      @click="onClick(f)"
    >
      <i v-if="!f.membership" class="fa fa-fw fa-user"></i>
      <i v-if="!!f.membership" class="fa fa-fw fa-id-card"></i>
      <span>{{ personToString(f, client) }}</span>
      <small v-if="!!f.membership" class="d-block text-muted pl-4">{{ f.membership.name }}</small>
    </b-dropdown-item>
    <b-dropdown-item
      v-if="!!adminItem"
      @click="onClickAdminItem"
    >
      <span class="text-danger">
        <i class="fa fa-fw fa-search"></i>
        {{ adminItem }}
      </span>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
  export default {
    props: {
      client: Object, // If empty, will use persons
      persons: Array, // If empty, will use the client's account members
      variant: {
        type: String,
        default: 'link',
      },
      label: {
        type: String,
        default: trans('choose_a_person'),
      },
      adminItem: {
        type: String,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        trans: trans,
        personToString: _.personToString,
      }
    },
    computed: {
      items() {
        // Group by email and by name
        let map = _.reduce(this.persons || this.client.account_members, (map, p) => {
          let key = _.camelCase(_.compact([p.name, p.email]).join(' ').replace(/\s+/, ''))
          p.key = key
          if (!map[key]) map[key] = []
          map[key].push(p)
          return map
        }, {})

        // Prioritize membership in the future, and mobile number
        return _.sortBy(_.map(_.values(map), persons => {
          persons.sort((a, b) => {
            if (!!a.membership && !b.membership) return -1
            if (!a.membership && !!b.membership) return 1
            if (!a.membership && !b.membership) {
              if (!!a.mobile && !b.mobile) return -1
              if (!a.mobile && !!b.mobile) return -1
              return 0
            }
            if (!a.membership.expired_at && !!b.membership.expired_at) return -1
            if (!!a.membership.expired_at && !b.membership.expired_at) return 1
            if (a.membership.expired_at == b.membership.expired_at) return 0
            return moment(a.membership.expired_at).isBefore(b.membership.expired_at)
          })
          return persons[0]
        }), ['key'])
      },
    },
    methods: {
      onClick(person) {
        this.$emit('person', person)
      },
      onClickAdminItem() {
        this.$emit('click-admin-item')
      },
    },
  }
</script>